export const forceUserLogout = () => {
    localStorage.clear();
    window.location.reload();
}